module.exports = __webpack_public_path__ + "img/vn_vn.b75b431d.png";